require('./angular-route');
module.exports = 'ngRoute';



//////////////////
// WEBPACK FOOTER
// ./~/angular-route/index.js
// module id = 40
// module chunks = 9 18 20